module.exports = __webpack_public_path__ + "img/button_email.0074a8aa.svg";